import { EventPresenterProps } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { StyledPresenter, StyledPresenterContainer, StyledLink } from "./StyledComponents";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface PresenterProps extends EventPresenterProps {
    isTranslucent?: boolean;
    showLink?: boolean;
    /**
     * for a11y roles
     */
    inGrid?: boolean;
}

/**
 * single Presenter used in media page
 */
export function Presenter(props: PresenterProps) {
    const { data, inGrid, showLink = true } = props;

    return (
        <StyledPresenterContainer role={inGrid ? "row" : undefined}>
            <div role={inGrid ? "gridcell" : undefined}>
                {showLink && (
                    <StyledLink href={data.link} aria-label={translate("Open profile page for %1", [data.name])}>
                        <StyledPresenter {...props} showPresenterModal={false} size={"large"} />
                    </StyledLink>
                )}
                {!showLink && <StyledPresenter {...props} size={"large"} />}
            </div>
        </StyledPresenterContainer>
    );
}

export default Presenter;
